import { isArray } from './utils';
import { DrEntity } from './dr-entity';
import { EntityType } from './enums';
import { TaggedEntity } from './tagged-entity';

export class Cluster extends DrEntity {
    attributes: any;
    childViewCount: number;
    clusterID: string;
    createdBy: string;
    createdOn: number;
    deDupeDocumentCount: number;
    description: string;
    documentCount: number;
    name: string;
    orderedCodeSets: any;
    sourceViewHandle: string;
    topTerms: any;
    viewType: string;
    visible: boolean;
    isClustered: boolean;
    entityType: EntityType;
    listingHandle: string;
    taggedEntityList: Array<TaggedEntity>;
    tagList: Array<TaggedEntity>;
    tagsTooltip: string;
    isParent: boolean;
    children: Array<Cluster>;
    data: any;

    constructor(value?: Partial<Cluster>) {
        super(value);
        if (value) {
            Object.assign(this, value);

            if (isArray(this.topTerms)) {
                this.topTerms = this.topTerms.join(', ').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&apos;');
            }

            if (this.taggedEntityList) {
                this.tagList = this.taggedEntityList.map(tag => new TaggedEntity(tag));
            }

            if (this.tagList && this.tagList.length > 3) {
                this.tagsTooltip = '';
                for (let i = 0; i < this.tagList.length; i++) {
                    this.tagsTooltip += this.tagList[i].name + (i < this.tagList.length - 1 ? '\x0A' : '');
                }
            }

            if (!this.clusterID) {
                this.topTerms = 'Unclaimed List';
            }

            if (this.handle) {
                this.listingHandle = this.handle;
            }

            this.attributes?.forEach((attribute) => {
                this[attribute] = attribute.value;
            });

            this.isClustered = true;
            this.entityType = EntityType.clusterView;
        }
    }
}
